import {gql, useQuery} from "@apollo/client";
import {DSP_FIELDS, DspType} from "../types/DspType";
import { useEffect, useState } from "react";

export const GET_DSPS_BY_WAREHOUSE_ID = gql`
  query GetDspsByWarehouseId($warehouseId: Long!) {
    dspList: getDspsByWarehouseId(warehouseId: $warehouseId) {
      ...DspFields
    }
  }
  ${DSP_FIELDS}
`;

export interface GetDspsByWarehouseIdResponse {
    dspList: DspType[];
}

export interface GetDspsByWarehouseIdVariables {
    warehouseId: number;
}

export const useDspsByWarehouseId = (warehouseId?: number) => {
    const [dsps, setDsps] = useState<DspType[]>([]);
    const {data, loading, error, refetch} = useQuery<GetDspsByWarehouseIdResponse, GetDspsByWarehouseIdVariables>(
        GET_DSPS_BY_WAREHOUSE_ID,
        {
            variables: { warehouseId: warehouseId! },
            skip: !warehouseId, // 当没有 warehouseId 时跳过查询
        }
    );
    
    useEffect(() => {
        if (data) {
           setDsps(data.dspList.map(dsp => ({...dsp, warehouseIds: dsp.warehouses.map(warehouse => Number(warehouse.id))})));
      }
    }, [data]);

  return {
    dsps,
    loading,
    refetch,
    error
  };
};
